import React from 'react'
import { usePaymentMethodPanelContext } from './Context'
import { formatMoney } from '@ztechapps/common.utils'
import { HorizontalStack } from '@ztechapps/webui.util'
export const PaidAndBalanceAmount = () => {
  const { totalPaid, balance } = usePaymentMethodPanelContext()

  return (
    <HorizontalStack gap={5} className={'py-4'}>
      <div>
        Paid: <span className={'fw-bold text-primary'}>{formatMoney(totalPaid)}</span>
      </div>
      <div>
        Balance: <span className={'fw-bold text-warning'}>{formatMoney(balance)}</span>
      </div>
    </HorizontalStack>
  )
}
